import { render, staticRenderFns } from "./receiptDescriptionsList.vue?vue&type=template&id=06e6f7fa&scoped=true&"
import script from "./receiptDescriptionsList.vue?vue&type=script&lang=js&"
export * from "./receiptDescriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./receiptDescriptionsList.vue?vue&type=style&index=0&id=06e6f7fa&lang=scss&scoped=true&"
import style1 from "./receiptDescriptionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6f7fa",
  null
  
)

export default component.exports